import './list_img.less';

const options = {
    elem: '.mu8-listimg',
    colCount: 5,
    space: 20,
    auto: true,
}

function init(newOptions){
    Object.assign(options, newOptions);
}

/**
 * 重置图片列表大小
 */
function render(newOptions) {
    if(newOptions){
        init(newOptions);
    }
    let totalWidth = $(options.elem).width();
    const imgWidth = 212; // 原始图片宽度
    const imgHeight = 159; // 原始图片高度
    let imgColCount = options.colCount; // 一行放置图片数量
    let space = options.space; // 间隔距离
    let scrollWidth = 0;
    const ratio = imgWidth / imgHeight; // 图片高度比
    if (totalWidth < 768) {
        imgColCount = 2;
        space = 10
    } else if (totalWidth < 992) {
        imgColCount = 3
        space = 10
    } else if (totalWidth < 1220) {
        imgColCount = 4;
        space = 20
    }

    const currImgWidth = (totalWidth - (imgColCount - 1) * space - scrollWidth) / imgColCount; // 当前图片的宽度
    const currImgHeight = currImgWidth / ratio; // 当前图片的高度

    // 设置图片容器和图片的高度和宽度
    $('.mu8-listimg-item').width(currImgWidth).each(function (i, item) {
        if ((i + 1) % imgColCount === 0 && i !== 0) {
            $(item).css('margin-right', '0');
        } else {
            $(item).css('margin-right', space + 'px');
        }
    }).find('.mu8-listimg-item-img').children().height(currImgHeight);
}

export default {
    init,
    render,
}